export enum CheckoutTermsActionType {
  TERMS_PENDING = "CHECKOUT.ACTIONS.BASKET_TERMS.PENDING",
  TERMS_SUCCESS = "CHECKOUT.ACTIONS.BASKET_TERMS.SUCCESS",
  TERMS_FAILURE = "CHECKOUT.ACTIONS.BASKET_TERMS.FAILURE",
  TERMS_TOGGLE_ALL_TERMS = "CHECKOUT.ACTIONS.BASKET_TERMS.TOGGLE_ALL_TERMS",
  TERMS_TOGGLE_TERMS = "CHECKOUT.ACTIONS.BASKET_TERMS.TOGGLE_TERMS",
  TERMS_ADD_TERM_TAB_REQUIRED_ID = "CHECKOUT.ACTIONS.BASKET_TERMS.ADD_TERM_TAB_REQUIRED_ID",
  TERMS_VALIDATION = "CHECKOUT.ACTIONS.BASKET_TERMS_VALIDATION",
  TERMS_ACTIVE_TERM_TAB_ID = "CHECKOUT.ACTIONS.BASKET_TERMS.BASKET_ACTIVE_TERM_TAB_ID",
}
